var _excluded = ["icon", "label", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../../foundations/Icon';
import { forwardRef } from '../../../../utils';
import { Container } from '../../..';
import { useBaseMenuContext } from '../../../BaseMenu/hooks';
import { _BaseTrigger } from '../_BaseTrigger';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private Please use `Menu.ActionTrigger`.
 */
export var ActionTrigger = forwardRef((_ref, ref) => {
  var {
    icon,
    label,
    size
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isOpen
  } = useBaseMenuContext(); // The icon has an aria-hidden attribute because the icon's aria-label shouldn't be announced by screen readers

  var leftIcon = icon && (size === 'medium' ? /*#__PURE__*/_jsx(Container, {
    alignItems: "center",
    paddingLeft: "xxs",
    children: /*#__PURE__*/_jsx(Icon, {
      "aria-hidden": true,
      size: "small",
      type: icon,
      color: "inherit"
    })
  }) : /*#__PURE__*/_jsx(Icon, {
    "aria-hidden": true,
    size: "small",
    type: icon,
    color: "inherit"
  })); // The icon has an aria-hidden attribute because the icon's aria-label shouldn't be announced by screen readers

  var caretIcon = size === 'medium' || !leftIcon ? /*#__PURE__*/_jsx(Icon, {
    "aria-hidden": true,
    type: isOpen ? 'caret-up' : 'caret-down',
    size: "small",
    color: "inherit"
  }) : /*#__PURE__*/_jsx(Container, {
    alignItems: "center",
    paddingRight: "xxs",
    children: /*#__PURE__*/_jsx(Icon, {
      "aria-hidden": true,
      type: isOpen ? 'caret-up' : 'caret-down',
      size: "small",
      color: "inherit"
    })
  });
  return /*#__PURE__*/_jsx(_BaseTrigger, _objectSpread(_objectSpread({
    "data-component": "Menu.ActionTrigger"
  }, props), {}, {
    size: size,
    leftElement: leftIcon,
    centerElement: label,
    rightElement: caretIcon,
    ref: ref
  }));
});
ActionTrigger.displayName = 'Menu.ActionTrigger';
//# sourceMappingURL=ActionTrigger.js.map